export default __webpack_public_path__ + "static/media/mission.5a1eff10.webp";